import { useEffect } from 'react';

// Type declaration for window.ENV is in app/types/window.d.ts

export function ServiceWorkerRegistration() {
  useEffect(() => {
    // Only register service worker in production or when explicitly enabled
    const nodeEnv = window.ENV?.NODE_ENV || 'development';
    const enableSW = window.ENV?.ENABLE_SW === 'true';

    if ('serviceWorker' in navigator && (nodeEnv === 'production' || enableSW)) {
      navigator.serviceWorker
        .register('/sw.js')
        .then(registration => {
          console.log('SW registered:', registration);
        })
        .catch(error => {
          console.log('SW registration failed:', error);
        });
    }
  }, []);

  return null; // This component doesn't render anything
}
